import { NativeImage } from "@/components/native/NativeImage";

interface GalleryThumbnailsProps {
  images: string[];
  currentIndex: number;
  onSelect: (index: number) => void;
  title: string;
}

const GalleryThumbnails = ({
  images,
  currentIndex,
  onSelect,
  title,
}: GalleryThumbnailsProps) => {
  if (images.length <= 1) return null;

  return (
    <div className="flex gap-2 mt-4 overflow-x-auto p-1">
      {images.map((image, index) => (
        <button
          key={index}
          onClick={() => onSelect(index)}
          className={`relative flex-none w-16 h-16 rounded-md overflow-hidden ${
            index === currentIndex ? "ring-2 ring-[#D4AF37]" : ""
          }`}
          aria-label={`Select image ${index + 1}`}
        >
          <NativeImage
            src={image}
            alt={`${title} thumbnail ${index + 1}`}
            className="w-full h-full object-cover"
          />
        </button>
      ))}
    </div>
  );
};

export default GalleryThumbnails;
